export default __webpack_public_path__ + "static/media/attack-icon.f5ebc295.svg";